---
title: actual conversations i definitely had at sparc
subtitle: entirely verbatim, trust me
date: 2024-08-03 21:45
---

import { Dialogue } from "#components/Dialogue";
import { Divider } from "#components/Divider";


<Dialogue short={true} content={`
me: so, what do you think are the pertinent parts to your identity?

camper: huh?

me: i mean, what parts of yourself do you think are important to making you, you?

camper: uh

camper: 

camper: i dunno

me: oh

me: what kinds of things do you like?

camper: video games?

me: oh same

camper: and books

me: wow me too
`} />

<Divider />

<Dialogue short={true} content={`
camper: so alice and bob are in different rooms and each see an infinite random series of coin flips

me: mhm

camper: then alice says an integer *i* and bob says an integer *j*, and they win if alice's *j*th coin flip and bob's *i*th coin flip are both heads

me: yep

camper: now if they pick randomly their chance of winning is one-fourth, but you can get one-third if you're clever, and you can get an even higher probability if you do some work...

me: ok?

camper: and now i'm writing out some code to check if there's an upper bound to the best chance of winning you can get for short numbers of coin flips, to try to see if i can prove something about this in general...

me: sure

me: i mean, cool problem

me: and you're working on this alone?

camper: yeah everyone's doing something else

me: is this what you want to be doing with your time

camper: uh

camper: yes?

[*camper leaves a few minutes later*]
`} />

<Divider />

<Dialogue short={true} content={`
camper: what's something you've been confused about lately?

me: well i went to the gym yesterday for the first time in six years

me: and while we were doing stretches someone asked me why i was going to the gym for the first time in a while

me: and i said i didn't *want* to go to the gym, but i *want to want* to go to the gym, you know?

camper: makes sense

camper: so why did you want to want that?

me: i mean, it's one of the big depression interventions i haven't given a try yet

me: or, well, i thought i've given it a try but a friend insisted that i haven't given it a serious one

camper: mhm

me: anyway i was explaining this to her and then i said i'm gonna start crying

me: and then i started crying

camper: i see

camper: why

me: dunno
`} />

<Divider />

<Dialogue short={true} content={`
camper: where are you from

me: well i lived in the philippines for eighteen years, and have been in the us for the last five

me: you?

camper: i was born in shanghai and i lived there for two years

me: uh huh

camper: then we moved to singapore and i lived there for three years

me: ok

camper: then we moved to oxford and i lived there for two years

me: sure

camper: then shanghai for three years, singapore for four years, sunnyvale for three years

me: that's a lot

camper: yeah

camper: i'm not sure how i feel about my cultural identity, what i identify with, or how much that even matters to me

me: ah

me: same
`} />

<Divider />

<Dialogue short={true} content={`
camper: my friends seem to think that my life is too perfect

camper: and i don't want that

me: why not?

camper: i think partly it makes them harder to relate to me

camper: but also, my life isn't perfect!

camper: there's things about it i don't like

me: and do your friends know about these things?

camper: no

me: well do you like, talk to them about it?

camper: no, i don't want to complain about things

camper: because complaining is bad

camper: it only makes you focus on the problem, which makes you feel worse

me: well, per litany of gendlin

me: what is true is already so

me: owning up to it doesn't make it worse

me: not being open about it doesn't make it go away

camper: hmm

camper: i guess i've kinda been taught by my mom not to complain

camper: and i felt a sense of pride because my older sister complains a lot, and i don't

camper: and i don't want to be known as the kind of person who complains

me: but like

me: people complain to their friends

me: that's a thing that friends do

me: it makes you closer, you know? you're disclosing something you don't like

me: which is more vulnerable than talking about something you do like

camper: huh

me: we can practice complaining now

me: what's something you want to complain about

camper: uh, let me think

camper: 

camper: 

camper: i'm sad that i didn't get into mit

me: oh, damn, that sucks

me: i was thinking closer to like

me: the dining hall food is bad
`} />

<Divider />

<Dialogue short={true} content={`
camper: so what *is* rationality

me: systematized...

other camper: winning!
`} />

<Divider />

<Dialogue short={true} content={`
me: sometimes i worry that my terminal values aren't noble enough

me: because to me the thing that matters is feeling good

me: which doesn't mean i want to only feel pleasure or joy

me: but i also want to feel meaningness and love and all the other stuff

me: a balanced diet of good feelings if you will

camper: i feel the same i think

camper: why are you so worried about it?

me: because the other people i talk to usually say they don't feel like that

me: they say they value things like, being with other people, or making a difference

me: and i only care about those things because they make me feel good

camper: well if you care about connection and impact

camper: then it sounds like you value those things

camper: and you're allowed to say those are your values

me: yeah, but only because they make me feel good

me: they're values, but they're not *terminal* values

me: the terminal value is a balanced diet of good feelings

camper: hm

me: people i talk to say they care about impact and that's it

me: they care about impact, not because it makes them feel good

me: but because they care about impact, period, whether or not it feels good

camper: but does it matter though

camper: if your intentions are less noble?

camper: it's not like you'd be doing different things if those *were* your values

me: huh

me: that's

me: that's a fair point

camper: cool well that's all our time today, i'll send the therapy invoice to your email
`} />

<Divider />

<Dialogue short={true} content={`
camper: does that mean you view yourself as getting more fractured over time?

me: not really? it's more like, the self has *already* been fractured by trauma

me: it's about discovering what parts are there, and integrating them as part of ourselves

me: rather than the parts being in conflict, the goal is to make them work together

camper: i see

me: yeah this is internal family systems

me: in the case of going to the gym, i think some part was trying to protect me

me: in the past i had some awful experiences from going to the gym with my father, so part of me avoided going to the gym with anyone to avoid getting hurt

me: and i had to talk to that part and say, hey, we're with a friend, and they're being nice to us, and we're safe

camper: huh, neat

me: yeah

me: 

me: so, let's talk about typescript
`} />

<Divider />

<Dialogue short={true} content={`
me: how's your day going

camper: not great tbh

camper: the past few days in sparc i've had one amazing day after another

camper: today was okay but nothing special

me: ah that sucks

me: but it happens

me: they can't all be winners

camper: yeah, i haven't had the energy to talk to people today

camper: how's your day going?

me: today wasn't a great day for me either

camper: why not?

me: the dining hall food was bad
`} />

<Divider />

<Dialogue short={true} content={`
camper: i've always wanted to feel my emotions more strongly

me: and why haven't you

camper: i don't know

camper: i try to pay attention to my feelings and all

camper: but that doesn't work

me: hm

me: what are you afraid will happen if you felt your emotions more strongly

camper: uh

camper: i'm afraid that i might get too sad

me: mhm

me: anything else?

camper: hm

camper: 

camper: i'm afraid if i get too angry i might push people away

camper: i'm afraid that i might not like what i feel about things

camper: 

camper: yeah

me: is that it?

camper: i, uh, i think so?

camper: i mean, those feel like the main reasons...

me: i bet you can list some more

me: in fact, i bet we can get to twenty

me: it doesn't have to be a super serious reason

me: name the first thing that comes to mind

camper: okay, uh

camper: i'm afraid if i felt my emotions more strongly then i might like, get addicted to feeling happy or something

[*camper list sixteen more things*]

me: and that's twenty!

me: thanks for sharing

me: how do you feel

camper: that was

camper: 

camper: that was a lot

[*camper starts crying*]

camper: but i think something changed

me: nice

camper: yeah

camper: 

camper: i should go pick up my laundry
`} />

<Divider />

<Dialogue short={true} content={`
me: alright, you wanted a take two

me: what do you think are the pertinent parts to your identity?

camper: oh yeah, i'm ready to answer this now

camper: i've spent a lot of time thinking about this in sparc the past few days

camper: like, what are the things i value? what are things i care about? how do i view myself?

camper: i've asked lots of people about this, and had lots of conversations about this

camper: i think i can say that i care deeply about problem solving

camper: i thought about the feeling that i get when things click together

camper: and how that gives me such joy

camper: i also care a lot about trying absurd things out and seeing what happens

camper: or as i say, "the funny"

camper: like, what if i raced across the room in a rolling chair right now?

camper: i could do that, and it'd be for the funny

camper: and i thought, maybe i'm only narrativizing why i make jokes and stuff

camper: that i'm saying it's for "the funny" when really i want to get the approval of others

camper: after reflecting on it, i can't rule that reason out for certain

camper: at the very least, that doesn't fully explain why i do funny things

me: wow

camper: so, solving problems, and "the funny"

camper: i think these are the two most important parts to my identity

me: that's deep

camper: ha i was just kidding

camper: i care about video games and books
`} />
